import { Box, Button, Text } from '@chakra-ui/react';

export interface INotificationProps {
	title: string;
	subtitle: string;
	action?: {
		text: string;
		onClick: () => void;
	};
}

export default function Notification(props: INotificationProps) {
	return (
		<Box
			py={4}
			px={6}
			bg="white"
			borderWidth={1}
			borderColor="gray.200"
			borderRadius="md"
			display="grid"
			gridTemplateColumns="1fr auto"
			alignItems="center"
			gap={2}
		>
			<Box>
				{<Text fontWeight="500">{props.title} </Text>}
				<Text fontSize="sm">{props.subtitle}</Text>
			</Box>

			{props.action ? (
				<Box>
					<Button variant="solid" colorScheme="primary" size="sm" onClick={props.action?.onClick}>
						{props.action?.text}
					</Button>
				</Box>
			) : null}
		</Box>
	);
}
